export default function Footer() {
  return (
    <footer className="bg-[#1c4444] text-gray-300 text-center py-6 rounded-t-[20px]">
      <p>© {new Date().getFullYear()} OutlookProject. All rights reserved.</p>
    </footer>
  );
}
